import { ErrorHandler, NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import * as fromComponents from './components';
import * as fromContainers from './containers';
import * as fromServices from './services';
import { ApiInterceptor } from './interceptors/api.interceptor';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CommentsModule } from '../comments/comments.module';
import { ErrorsHandler } from '@ml/core/providers/errors-handler.provider';
import { NotificationsModule } from '@ml/notifications/notifications.module';

@NgModule({
  imports: [SharedModule, CommentsModule, NotificationsModule],
  declarations: [...fromComponents.components, ...fromContainers.containers],
  entryComponents: [
    fromContainers.ChangePasswordComponent
  ],
  providers: [
    {
      ...fromServices.services,
      // http interceptor and http client need to be in the same module so it works
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'fill' }
    },
    {
      provide: ErrorHandler,
      useClass: ErrorsHandler
    },
    {
      provide: MatPaginatorIntl,
      useClass: fromServices.CustomMatPaginatorIntl
    }
  ],
  exports: [HttpClientModule, fromContainers.ChangePasswordPageComponent]
})
export class CoreModule { }
